import React, { useEffect, useState } from 'react'
import user from '../../images/image (32).png'
import search from '../../images/search-interface-symbol (3) 1.png'
import filter from '../../images/sort (2) 1.png'
import userAvatar from '../../images/user-avatar (1) 9.png'
import toast from 'react-hot-toast'
import HttpClient from '../../utils/HttpClient'
import Loader from '../../Loader/Loader'
import './ProjectPopUp.css';
import { FaEye } from 'react-icons/fa'
import { formatDateTime } from '../../Helper/Helper'
import './Milestone.css'

const Milestone = () => {
    const [modal, setModal] = useState(false);
    const [milestones, setMilestone] = useState([]);
    const [filteredMilestones, setFilteredMilestones] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [budgetDetails, setBudgetDetails] = useState([]);
    const [showBudgetModal, setShowBudgetModal] = useState(false);
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [singleProjectId, setSingleProjectId] = useState('');

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedMilestoneId, setSelectedMilestoneId] = useState(null);

    const handleDeleteClick = (milestoneId) => {
        setSelectedMilestoneId(milestoneId);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            setLoader(true);
            const res = await HttpClient.requestData(
                `deletemilestone/${selectedMilestoneId}`,
                'DELETE'
            );

            if (res && res.status) {
                toast.success(res.message || 'Milestone deleted successfully');
                fetchAllMilestoneData(); // Refresh the list
            } else {
                toast.error(res?.message || 'Failed to delete milestone');
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to delete milestone');
        } finally {
            setLoader(false);
            setShowDeleteModal(false);
            setSelectedMilestoneId(null);
        }
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
        setSelectedMilestoneId(null);
    };

    const [formData, setFormData] = useState({
        projectId: '',
        fromMilestoneId: '',
        toMilestoneId: '',
        taskId: '',
        // fromMilestonePercentage: '',
        // toMilestonePercentage: '',
        fromMilestoneAmount: '',
        toMilestoneAmount: '',
    });

    const [projects, setProjects] = useState([]);
    const [milestoneOfProject, setMilestoneOfProject] = useState([]);

    const fetchAllProjects = async () => {
        try {
            setLoader(true);
            const res = await HttpClient.requestData('view-all-project', 'GET');
            if (res && res?.status) {
                setProjects(res?.data);
            } else {
                setProjects([]);
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            setProjects([]);
            toast.error(error?.message || 'something went wrong!!!');
        } finally {
            setLoader(false);
        }
    };

    const toggleBudgetModal = () => {
        setShowBudgetModal(!showBudgetModal);
    };

    const toggleTaskModal = () => {
        setShowTaskModal(!showTaskModal);
    };

    const fetchAllMilestoneData = async () => {
        try {
            setLoader(true);
            const res = await HttpClient.requestData('getmymilestone', 'GET');
            if (res && res?.status) {
                setMilestone(res?.data);
            } else {
                setMilestone([]);
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            setMilestone([]);
            toast.error(error?.message || 'something went wrong!!!');
        } finally {
            setLoader(false);
        }
    };

    const fetchAllMilestoneByProjectId = async projectId => {
        try {
            setLoader(true);
            const res = await HttpClient.requestData('getmilestonebyprojectId', 'POST', {
                projectId,
            });
            if (res && res?.status) {
                setMilestoneOfProject(res?.data);
            } else {
                setMilestoneOfProject([]);
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            setMilestoneOfProject([]);
            toast.error(error?.message || 'something went wrong!!!');
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (formData?.projectId) {
            fetchAllMilestoneByProjectId(formData?.projectId);
        }
    }, [formData?.projectId]);


    useEffect(() => {
        fetchAllMilestoneData();
        fetchAllProjects();
    }, []);

    const handleInputChange = e => {
        const { name, value } = e.target;
        console.log('name: ', name, 'value: ', value);

        setFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
        if (name === 'fromMilestoneId') {
            const selectedMilestone = milestoneOfProject?.find(item => item?._id === value);
            setTasks(selectedMilestone?.tasks || []);
        }
    };

    const handleTaskMovement = async e => {
        e.preventDefault();
        if (!formData.projectId) {
            return toast.error('Project must be required!!!');
        }

        if (!formData.fromMilestoneId) {
            return toast.error('From Milestone must be required!!!');
        }

        if (!formData.toMilestoneId) {
            return toast.error('To Milestone must be required!!!');
        }

        if (!formData.taskId) {
            return toast.error('Task must be required!!!');
        }

        if (!formData.toMilestoneAmount) {
            return toast.error('To Milestone amount must be required!!!');
        }

        try {
            const res = await HttpClient.requestData('movetask', 'POST', {
                ...formData,
                fromMilestoneAmount: formData?.fromMilestoneAmount ? +formData?.fromMilestoneAmount : 0,
                toMilestoneAmount: formData?.fromMilestoneAmount ? +formData?.toMilestoneAmount : 0,
            });
            if (res && res?.status) {
                toast.success(res?.message || 'Task moved successfully');
                setModal(false); // close the modal ...
                setFormData({ // reset the form ....
                    projectId: '',
                    fromMilestoneId: '',
                    toMilestoneId: '',
                    taskId: '',
                    fromMilestonePercentage: '',
                    toMilestonePercentage: '',
                });
                fetchAllMilestoneData(); // to refresh the milestone table ...
            } else {
                toast.error(res?.error ? res?.error : res?.message ? res?.message : 'something went wrong!!!');
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
        }
    }

    // console.log('formData: ', formData);
    // console.log('tasks: ', tasks);

    useEffect(() => {
        if (milestones?.length) {
            setFilteredMilestones(milestones);
        } else {
            setFilteredMilestones([]);
        }
    }, [milestones]);

    const getExistingMilestonesByProjectId = async projectId => {
        try {
            const res = await HttpClient.requestData('getmilestonebyprojectId', 'POST', {
                projectId,
            });
            if (res && res?.status) {
                console.log("milestone res of selected project id: ", res);
                setFilteredMilestones(res?.data);
            } else {
                toast.error(res?.message || 'something went wrong!!!');
                setFilteredMilestones([]);
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
            setFilteredMilestones([]);
        }
    };

    useEffect(() => {
        if (singleProjectId?.length) {
            getExistingMilestonesByProjectId(singleProjectId);
        } else {
            setFilteredMilestones(milestones);
        }
    }, [singleProjectId]);

    console.log('singleProjectId: ', singleProjectId);

    console.log('filteredMilestones: ', filteredMilestones);




    const EditModal = () => {
        return (
            <>
                <div className='edit_modal_wrapper'></div>
                <i onClick={(() => setModal(false))} class="fa-regular fa-circle-xmark" style={{
                    cursor: 'pointer'
                }}></i>
                <div className='edit_modal_div'>

                    <h3>Task Movement</h3>
                    <form className='mt-4 edit_form_85956'>
                        <div className='edit_form_label_wrapper'>
                            <label>Project</label>
                            <select name='projectId' value={formData.projectId} onChange={handleInputChange}>
                                <option value=''>select project</option>
                                {
                                    projects?.length > 0 ? projects?.map((e, i) => (
                                        <option key={i} value={e?._id}>{e?.projectName || '-'}</option>
                                    )) : (<option value=''>No Projects Found ...</option>)
                                }
                            </select>
                        </div>

                        <div className='edit_form_label_wrapper'>
                            <label>From Milestone</label>
                            <select value={formData?.fromMilestoneId} name='fromMilestoneId' onChange={handleInputChange}>
                                <option value=''>select from milestone</option>
                                {
                                    milestoneOfProject?.length > 0 ? milestoneOfProject?.map((e, i) => (
                                        <option key={i} value={e?._id}>{e?.milestoneName || '-'}</option>
                                    )) : (
                                        <option value=''>No Milestone Found ...</option>
                                    )
                                }
                            </select>
                        </div>

                        <div className='edit_form_label_wrapper'>
                            <label>Select Task</label>
                            <select value={formData?.taskId} name='taskId' onChange={handleInputChange}>
                                <option value={''}>select tasks</option>
                                {
                                    tasks?.length > 0 ? tasks?.map((e, i) => (
                                        <option value={e?.taskId} key={i}>{e?.fullDetails?.taskName || '-'}</option>
                                    )) : (
                                        <option value=''>No Tasks Found ...</option>
                                    )
                                }
                            </select>
                        </div>

                        <div className='edit_form_label_wrapper'>
                            <label>To Milestone</label>
                            <select value={formData?.toMilestoneId} name='toMilestoneId' onChange={handleInputChange}>
                                <option value=''>select to milestone</option>
                                {
                                    milestoneOfProject?.length > 0 ? milestoneOfProject?.map((e, i) => (
                                        <option key={i} value={e?._id}>{e?.milestoneName || '-'}</option>
                                    )) : (
                                        <option value=''>No Milestone Found ...</option>
                                    )
                                }
                            </select>
                        </div>

                        <div className='edit_form_label_wrapper'>
                            <label>From Milestone Amount</label>
                            <input type='number' value={formData?.fromMilestoneAmount} name='fromMilestoneAmount' onChange={handleInputChange} />
                        </div>

                        <div className='edit_form_label_wrapper'>
                            <label>To Milestone Amount</label>
                            <input type='number' value={formData?.toMilestoneAmount} name='toMilestoneAmount' onChange={handleInputChange} />
                        </div>



                        {/* <div className='edit_form_label_wrapper'>
                            <label>To Milestone Percentage</label>
                            <input type='number' value={formData?.toMilestonePercentage} name='toMilestonePercentage' onChange={handleInputChange} />
                        </div> */}
                    </form>

                    <button
                        type='button'
                        onClick={handleTaskMovement}>Move</button>
                </div>


            </>
        )
    }

    return (
        <>
            {
                loader && (<Loader />)
            }
            {modal && <EditModal />}
            <div className='user_permission_wrapper'>
                <div className='user_access_head'>Milestone Creation</div>
                <div className='user_permission_table_Wrapper'>
                    <div className='team_search_wrapper'>
                        <h6 style={{
                            fontSize: '25px'
                        }}>Milestones</h6>
                        <div className='user_search_input_wrapper' style={{
                            marginLeft: 'auto'
                        }}>
                            <div className='project_filter_dropdown_milestone_container'>
                                <select style={{
                                    width:'130px',
                                    textOverflow:'ellipsis',
                                    overflow:'hidden'
                                }} onChange={e => setSingleProjectId(e?.target?.value)}>
                                    <option value={''}>All</option>
                                    {
                                        projects?.length > 0 ? projects?.map((e, i) => (
                                            <option key={i} value={e?._id}>{e?.projectName || '-'}</option>
                                        )) : (<option value=''>No Projects Found ...</option>)
                                    }
                                </select>
                            </div>

                            <div
                               className='move_tasK_btn'
                                onClick={() => setModal(!modal)}
                                style={{
                                    padding: '7px 20px',
                                    borderRadius: '8px',
                                    color: '#fff',
                                    background: '#0c2637',
                                    cursor: 'pointer',
                                }}>Move Task</div>
                        </div>
                    </div>
                    <table className='user_permission_table'>
                        <thead className='thead_row' style={{
                            position: 'sticky',
                            top: 0,
                        }}>
                            <tr className='thead_row'>
                                {/* <th className='user_table_head1'> Not-Assigned ID</th>
                                <th className='user_table_head2'>Manager</th>
                                <th className='user_table_head3'>Second</th>
                                <th className='user_table_head4'>Rollback</th>
                                <th className='user_table_head5'>Total User</th> */}

                                <th className='user_table_head1'>Milestone ID</th>
                                <th className='user_table_head3'>Phase Name</th>
                                <th className='user_table_head2'>Phase Amount</th>
                                <th className='user_table_head2'>Milestone Name</th>
                                <th className='user_table_head3'>Project Name</th>
                                <th className='user_table_head2'>Total Budget</th>
                                <th className='user_table_head3'>Budget As Of Now</th>
                                <th className='user_table_head3'>Task Details</th>
                                <th className='user_table_head3'>Project Budget Details</th>
                                <th className='user_table_head3'>Milestone Status</th>
                                <th className='user_table_head3'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {[1, 2, 3, 4, 5, 6, 7, 1, 2, 5, 6, 2, 4, 5].map((e, i) => {
                                return (
                                    <>
                                        <tr>
                                            <td><div className='id_wrapper'>
                                                <input type='checkbox' />
                                                11123465765
                                            </div> </td>
                                            <td>1000</td>
                                            <td>Men</td>
                                            <td>Shirt</td>
                                            <td>
                                                <div className='user_circle_div_wrapper'>
                                                    <img className='user_img' src={user} alt='...' />
                                                    <img className='user_img' src={user} alt='...' />
                                                    <img className='user_img' src={user} alt='...' />

                                                    <p>50</p>
                                                    <img onClick={(() => {
                                                        setModal(!modal)
                                                    })} src={userAvatar}
                                                        style={{
                                                            width: '18px',
                                                            height: '18px',
                                                            marginTop: '2px',
                                                            marginLeft: '15px',
                                                            cursor: 'pointer'
                                                        }}
                                                        alt='...'
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </>
                                )
                            })} */}


                            {filteredMilestones?.length > 0 ? filteredMilestones.map((e, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <tr>
                                            <td><div className='id_wrapper'>
                                                {/* <input type='checkbox' /> */}
                                                {(i + 1) || '-'}
                                            </div> </td>
                                            <td>{e?.phaseId?.name || '-'}</td>
                                            <td>{e?.phaseId?.amount || '0'}</td>
                                            <td>{e?.milestoneName || '-'}</td>
                                            <td>{e?.projectDetails?.projectName || '-'}</td>
                                            <td>{e?.projectDetails?.budget || '0'}</td>
                                            <td style={{
                                                textAlign: 'center'
                                            }}>{e?.projectDetails?.nowbudget || '0'}</td>
                                            <td
                                                onClick={() => {
                                                    setTasks(e?.tasks || []);
                                                    toggleTaskModal();
                                                }}
                                                style={{
                                                    paddingLeft: '50px'
                                                }} ><FaEye style={{ cursor: 'pointer' }} /></td>
                                            <td
                                                onClick={() => {
                                                    setBudgetDetails(e?.projectDetails?.budgetDetails || []);
                                                    toggleBudgetModal();
                                                }}
                                                style={{
                                                    textAlign: 'center'
                                                }} ><FaEye style={{ cursor: 'pointer' }} /></td>

                                            <td style={{
                                                textAlign: 'center'
                                            }}>{e?.isCompleted ? 'Completed' : 'Not Completed'}</td>    

                                            <td>
                                                <i
                                                    className="fa-solid fa-trash"
                                                    style={{
                                                        cursor: 'pointer',
                                                        color: '#ff4d4f'
                                                    }}
                                                    onClick={() => handleDeleteClick(e._id)}
                                                ></i>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                )
                            }) : (
                                <tr>
                                    <td colSpan={7} style={{
                                        textAlign: 'center',
                                    }}>No Milestone Data Found ...</td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
            </div>

            {/* Budget Details Modal */}
            {showBudgetModal && (
                <div className="modal-overlay">
                    <div className="budget-modal">
                        <div className="modal-header">
                            <h3>Budget Breakdown</h3>
                            <button className="close-modal" onClick={toggleBudgetModal}>
                                <i className="fa-solid fa-x"></i>
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="budget-table">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Amount</th>
                                        <th>My Profit</th>
                                        <th>To Be Used</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {budgetDetails?.length > 0 ? budgetDetails?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.title || '-'}</td>
                                            <td>{item.amount || 0}</td>
                                            <td>{item.myProfit || 0}</td>
                                            <td>{item.toBeUsed || 0}</td>
                                            <td>{item.notes || '-'}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={5} style={{
                                                textAlign: 'center',
                                            }}>No Budget Details Data Found ...</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}


            {/* Task of particular project details modal */}
            {showTaskModal && (
                <div className="modal-overlay">
                    <div className="budget-modal">
                        <div className="modal-header">
                            <h3>Tasks BreakDown</h3>
                            <button className="close-modal" onClick={toggleTaskModal}>
                                <i className="fa-solid fa-x"></i>
                            </button>
                        </div>
                        <div className="table-container">
                            <table className="budget-table">
                                <thead>
                                    <tr>
                                        <th>Task Id</th>
                                        <th>Task Name</th>
                                        <th>Task Notes</th>
                                        <th>Task Status</th>
                                        <th>Select Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tasks?.length > 0 ? tasks?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{(index + 1) || '-'}</td>
                                            <td>{item?.fullDetails?.taskName || '-'}</td>
                                            <td>{item?.fullDetails?.taskNotes || '-'}</td>
                                            <td>{item?.fullDetails?.taskStatus || '-'}</td>
                                            <td>{formatDateTime(item?.fullDetails?.selectDate) || '-'}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={5} style={{
                                                textAlign: 'center',
                                            }}>No Tasks Found ...</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="modal-overlay">
                    <div className="delete-confirmation-modal">
                        <div className="modal-header">
                            <h3>Confirm Deletion</h3>
                            <button className="close-modal" onClick={handleDeleteCancel}>
                                <i className="fa-solid fa-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this milestone? This action cannot be undone.</p>
                        </div>
                        <div className="modal-footer">
                            <button className="cancel-btn" onClick={handleDeleteCancel}>
                                Cancel
                            </button>
                            <button className="delete-btn" onClick={handleDeleteConfirm}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default Milestone
